import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Procesador transparente — el usuario nunca permanece aquí.
 * Verifica el token y redirige inmediatamente:
 *   éxito  → /
 *   fallo  → /login?linkExpired=1
 *   sin token → /register
 */
const VerifyEmail = () => {
  const navigate = useNavigate();
  const { verifyEmail, isAuthenticated, loading: authLoading } = useAuth();

  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get('token');
  const urlEmail = params.get('email');
  const urlOtp   = params.get('otp');

  const hasToken      = !!urlToken;
  const hasLegacyOtp  = !urlToken && !!(urlEmail && urlOtp);
  const hasAutoVerify = hasToken || hasLegacyOtp;

  const ran = useRef(false);

  useEffect(() => {
    if (authLoading) return;

    if (isAuthenticated) {
      navigate('/', { replace: true });
      return;
    }

    if (!hasAutoVerify) {
      navigate('/register', { replace: true });
      return;
    }

    if (!ran.current) {
      ran.current = true;

      (async () => {
        const result = hasToken
          ? await verifyEmail(null, null, urlToken)
          : await verifyEmail(urlEmail, urlOtp);

        if (result.success) {
          navigate('/', { replace: true });
        } else {
          navigate('/login?linkExpired=1', { replace: true });
        }
      })();
    }
  }, [authLoading, isAuthenticated, hasAutoVerify, hasToken, urlToken, urlEmail, urlOtp, verifyEmail, navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '80vh',
      backgroundColor: '#0a0e17',
    }}>
      <p style={{
        fontSize: '10px',
        letterSpacing: '5px',
        color: '#555555',
        textTransform: 'uppercase',
        margin: 0,
      }}>
        Verificando acceso...
      </p>
    </div>
  );
};

export default VerifyEmail;
